import { useContext, useMemo, useState } from "react";
import { ApiServiceContext } from "../../api/ApiService.context"
import { AppPage } from "../../components/Page/Page"

export const DataPage = () => {
    const ApiService = useContext(ApiServiceContext);
    const error = ApiService.mocked ? '' : 'Mocking is not enabled. No data to show.'
    const tableNames = Object.keys(ApiService.mockCRUD?.db().tables || {});
    const [selectedTableName, setSelectedTableName] = useState<string>('None');

    const recordsVal = useMemo(() => {
        let recs: Record<string, any>[] = [];
        const table = ApiService.mockCRUD?.db().tables[selectedTableName];
        if (table) {
            recs = Object.values(table._records).map(rec => rec.values as Record<string, any>);
        }
        return JSON.stringify(recs, null, 2);
    }, [selectedTableName, ApiService.mockCRUD]);

    return (
        <AppPage title="Data" >
            {
                error ? <p>{error}</p> : (
                    <div>
                        <div>
                            <select onChange={e => {
                                setSelectedTableName(e.target.value)
                            }}>
                                <option value="None" >None</option>
                                {
                                    tableNames.map(table => (
                                        <option value={table} >{table}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <textarea className="app-data-output" value={recordsVal} ></textarea>
                    </div>
                )
            }
        </AppPage>
    )
}